import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\"><path d=\"M510.6 64.9C263.4 64.9 63 265.3 63 512.5S263.4 960 510.6 960s447.6-200.4 447.6-447.6S757.7 64.9 510.6 64.9z m174.9 464.3L374.9 708.6c-12.9 7.4-29-1.9-29-16.7V333.1c0-14.9 16.1-24.2 29-16.7l310.6 179.3c12.9 7.5 12.9 26.1 0 33.5z\" p-id=\"7286\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol